import type { InputHTMLAttributes, ReactElement } from 'react';

/**
 * A tick box alone in a table cell (no words beside it; its name is its aria-label). Its label wraps it, so on a
 * touch screen the 44 by 44 px around the box is the target (rule 9, docs/specs/ui-layout-rules.md); with a mouse it
 * looks as a plain tick box does.
 */
export function TickCell(
  props: Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & { readonly 'aria-label': string },
): ReactElement {
  return (
    <label className="tick-cell">
      <input type="checkbox" {...props} />
    </label>
  );
}
